import faviconStaging from '../images/favicon-staging.png';
import faviconUat from '../images/favicon-uat.png';

const ENVIRONMENTS = {
    'https://api.weezevent.com': 'production',
    'https://api.weezevent.be': 'staging',
    'https://api.uat.weezevent.be': 'uat'
};

// We set a special favicon on uat/staging to make it easier to recognize tabs in the tab bar.
const FAVICON_OVERRIDES = {
    staging: faviconStaging,
    uat: faviconUat
};
try {
    const environment = ENVIRONMENTS[window.weezConfig.api.apiUrl];
    const icon = FAVICON_OVERRIDES[environment];
    if (icon) {
        document.querySelector('link[rel~="icon"]').setAttribute('href', icon);
    }
} catch {
    // This should never crash the app
}
